import Discipline from "../../../api/models/discipline";
import User from "../../../api/models/user";

export type DashboardProps = {
    discipline?: Discipline;
    user: User;
}
export const DashboardPropsDefaults = {
    containerClassNames: 'w-full h-full dashboard-widget col-span-1 bg-white rounded-lg shadow p-2 pt-1 pb-1 mr-1 mb-6 overflow-scroll overflow-x-hidden drop-shadow drop-shadow-lg scrollbar',
    contentClassNames: 'dashboard-widget-content text-sm pb-2'
}